<section class="projects-page insights-page">
  <div class="insights-shell">
  <header class="insights-hero">
    <div class="insights-hero-copy">
      <h1>Projects</h1>
      <p class="insights-lead">
        Manage every project in the workspace.
      </p>
    </div>

    @if (!loading() || loaded()) {
      <a
        class="btn btn-primary"
        routerLink="/projects/project"
      >
        <i class="bi bi-plus-lg me-1"></i>
        <span>New project</span>
      </a>
    }
  </header>

  @if (loading() && !loaded()) {
    <section class="loading-card">
      <div class="text-center py-4">
        <div class="spinner-border spinner-border-lg" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <p class="loading-copy">Loading all projects...</p>
    </section>
  } @else if (!projects().length) {
    <section class="state-card">
      <h2>No projects found</h2>
      <p>There are no projects yet. Create the first one to get started.</p>
      <div>
        <a
          class="btn btn-primary"
          routerLink="/projects/project"
          [queryParams]="{ from: 'projects' }"
        >
          Create project
        </a>
      </div>
    </section>
  } @else {
    <app-search-input
      class="project-search"
      ariaLabel="Search projects"
      placeholder="Search projects…"
      [(value)]="searchTerm"
    />

    @if (!filteredProjects().length) {
      <section class="state-card">
        <h2>No matching projects</h2>
        <p>No projects match "{{ searchTerm().trim() }}".</p>
      </section>
    }

    <section class="project-grid" aria-label="Projects">
      @for (project of filteredProjects(); track project.id) {
        <article
          class="project-card"
          tabindex="0"
          role="button"
          [attr.aria-label]="'Open ' + (project.name || 'Untitled project')"
          (click)="goToProject(project)"
          (keydown.enter)="goToProject(project)"
          (keydown.space)="goToProject(project); $event.preventDefault()"
        >
          <app-project-preview
            [logoUrl]="project.logoUrl"
            [color]="projectColor(project)"
            [name]="project.name"
            [description]="project.description"
            [billable]="project.billable"
          />
          <div class="project-card-footer">
            <div
              class="avatar-stack"
              [attr.aria-label]="project.users.length + (project.users.length === 1 ? ' member' : ' members')"
            >
              @for (user of project.users.slice(0, 4); track user.id) {
                <span class="avatar" aria-hidden="true">{{ ((user.name || user.email || '?').charAt(0) | uppercase) }}</span>
              }
              @if (project.users.length > 4) {
                <span class="avatar avatar-more" aria-hidden="true">+{{ project.users.length - 4 }}</span>
              }
            </div>
            <span class="project-meta">Updated {{ formatUpdatedAt(project) }}</span>
          </div>
        </article>
      }
    </section>
  }
  </div>
</section>
